<template>
  <v-card
    rounded="xl"
    outlined
    :class="{ 'EntregaEpiCard--selected': selected, 'EntregaEpiCard--clickable': selectable }"
    @click="selectable ? $emit('toggle-select') : null"
  >
    <v-card-title class="pb-2">
      <v-row no-gutters align="center">
        <v-col v-if="selectable" cols="auto" class="pr-2">
          <v-checkbox
            :input-value="selected"
            hide-details
            class="mt-0 pt-0"
            color="primary"
            @click.stop
            @change="$emit('toggle-select')"
          />
        </v-col>
        <v-col>
          <v-chip class="primary--text" color="#F0F6FA">{{ entrega.epiNome }}</v-chip>
        </v-col>
        <v-col cols="auto">
          <v-chip small outlined :color="statusColor">{{ statusLabel }}</v-chip>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="pt-0">
      <p class="mb-2">
        <v-icon class="mr-1" size="20" color="primary">mdi-account-check</v-icon>
        <strong>Responsável:</strong> {{ entrega.responsavelEntrega }}
      </p>
      <p class="mb-2">
        <v-icon class="mr-1" size="20" color="primary">mdi-calendar</v-icon>
        <strong>Data da entrega:</strong> {{ entrega.dataEntrega }}
      </p>
      <p class="mb-2">
        <v-icon class="mr-1" size="20" color="primary">mdi-calendar-clock</v-icon>
        <strong>Validade:</strong> {{ entrega.dataVencimento }}
      </p>
      <p class="mb-0">
        <v-icon class="mr-1" size="20" color="primary">mdi-package-variant-closed</v-icon>
        <strong>Quantidade:</strong> {{ entrega.quantidade }}
      </p>
    </v-card-text>

    <template v-if="entrega.dtConfirmacaoEntrega">
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" text block :loading="loadingPdf" @click.stop="abrirComprovante">
          <v-icon left>mdi-file-pdf-box</v-icon>
          Ver Comprovante
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import entregaEpiService from '@/services/entregaEpi'

const STATUS_LABELS = {
  aguardando_confirmacao: 'Aguardando confirmação',
  vigente: 'Vigente',
  proximo_vencimento: 'Próximo do vencimento',
  vencido: 'Vencido',
  pendente_entrega: 'Pendente entrega'
}

const STATUS_COLORS = {
  aguardando_confirmacao: 'info',
  vigente: 'success',
  proximo_vencimento: 'warning',
  vencido: 'error',
  pendente_entrega: 'info'
}

export default {
  name: 'EntregaEpiCard',
  props: {
    entrega: {
      type: Object,
      required: true
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingPdf: false
    }
  },
  computed: {
    statusLabel() {
      return STATUS_LABELS[this.entrega.status] || this.entrega.status
    },
    statusColor() {
      return STATUS_COLORS[this.entrega.status] || 'info'
    }
  },
  methods: {
    async abrirComprovante() {
      this.loadingPdf = true
      try {
        const response = await entregaEpiService.downloadComprovante(this.entrega.id)
        const data = response.data

        if (data && data.url) {
          window.open(data.url, '_blank')
        } else if (data instanceof Blob || data.type === 'application/pdf') {
          const fileURL = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
          window.open(fileURL, '_blank')
        } else {
          console.warn('[FRONT DEBUG] Formato não reconhecido!')
          this.$showErrorMessage('Link do comprovante inválido.')
        }
      } catch (error) {
        console.error('[FRONT DEBUG] Erro na requisição:', error)
        this.$showErrorMessage('Comprovante não encontrado.')
      } finally {
        this.loadingPdf = false
      }
    }
  }
}
</script>

<style scoped>
.EntregaEpiCard--selected {
  border-color: var(--v-primary-base) !important;
  background-color: #f8fbff;
}

.EntregaEpiCard--clickable {
  cursor: pointer;
}
</style>
